import React, { ComponentType, forwardRef } from 'react'
import { useTheme } from './useTheme'
import { ThemeProps } from './theme.types'

export const withTheme = <P extends object>(Component: ComponentType<P & ThemeProps>) => {
  const WithThemeComponent = forwardRef<any, P>((props, ref) => {
    const { theme } = useTheme()

    return <Component {...props} theme={theme} ref={ref} />
  })

  return WithThemeComponent
}
